module.exports = __webpack_public_path__ + "static/media/25487631_1703514063057111_5939932220537995206_o.ba6844ca.jpg";